package com.anjuros.website.templates.template4.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.components.contactform.ContactForm
import com.anjuros.website.templates.selection.components.contactform.ContactFormDetailsType
import com.anjuros.website.templates.selection.components.contactform.ContactFormInfo
import com.anjuros.website.templates.selection.components.contactform.EMAIL_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.MESSAGE_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.NAME_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.PHONE_NUMBER_CONTACT_FORM
import com.anjuros.website.templates.selection.components.contactform.SuccessContactMessage
import com.anjuros.website.templates.selection.components.contactform.requiredValidator
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template2.modules.Template2Theme
import com.anjuros.website.templates.template2.modules.getColor
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.Template4ContactStyle
import com.anjuros.website.templates.template4.styles.Template4FormWidthStyle
import com.anjuros.website.templates.template4.util.ResKey
import com.anjuros.website.templates.template4.util.Template4CompanyDetails
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEntered
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4ContactSection(showContactForm:Boolean = false){
    Box(
        modifier = Modifier
            .id(Template4Section.Contact.id)
            .fillMaxSize()
            .padding( bottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally) {
            Template4ContactContent(modifier = Modifier
                .margin(bottom = 50.px))
            if(showContactForm) {
                Template4ContactBox()
            }
        }
    }
}

@Composable
fun Template4ContactContent(modifier: Modifier){
    val animatedMargin= remember { mutableStateOf(50.px) }



    Template4ObserverViewportEntered(
        sectionId = Template4Section.Contact.id,
        distanceFromTop = 250.0
    ){
        animatedMargin.value=0.px
    }
    Row (modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically){
        AnjurosImage(
            src = Template4Res.Image.template4_contact1,
            alt = "Web design for self-employed sole traders UK",
            modifier = Modifier.displayIfAtLeast(Breakpoint.MD).height(400.px).fillMaxWidth(33.percent).objectFit(ObjectFit.Fill)
        )
        Box(modifier = Template4ContactStyle.toModifier().height(400.px).backgroundColor(Template4Theme.Primary.getColor())){

            Column (modifier = Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.SpaceAround) {
                Column(
                    modifier = Modifier.fillMaxSize(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    P(
                        attrs = Modifier

                            .margin(top=animatedMargin.value)
                            .transition(
                                Transition.of("margin", 1100.ms,
                                delay = 300.ms))
                            .fontFamily(Template4Constants.FONT_FAMILY)
                            .fontSize(36.px)
                            .color(Colors.White)
                            .fontWeight(FontWeight.Bold)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE4_CONTACT))

                    }
                    P(
                        attrs = Modifier

                            .margin(top=animatedMargin.value*0.7)
                            .transition(
                                Transition.of("margin", 700.ms,
                                    delay = 200.ms))

                            .fontFamily(Template4Constants.FONT_FAMILY)
                            .fontSize(20.px)
                            .color(Colors.White)
                            .fontWeight(FontWeight.Normal)
                            .toAttrs()
                    ) {
                        Text(LocalText(ResKey.TEMPLATE4_QUOTE))

                    }
                }
                    Column(
                        modifier = Modifier.fillMaxSize(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Link(path = "tel:${Template4Constants.CLIENTS_PHONE}",
                            modifier=Modifier.textDecorationLine(TextDecorationLine.None)) {
                            P(
                                attrs = Modifier

                                    .margin(top = animatedMargin.value * 0.8)
                                    .transition(
                                        Transition.of(
                                            "margin", 900.ms,
                                            delay = 500.ms
                                        )
                                    )

                                    .fontFamily(Template4Constants.FONT_FAMILY)
                                    .fontSize(24.px)
                                    .color(Colors.White)
                                    .fontWeight(FontWeight.Bold)
                                    .toAttrs()
                            ) {
                                AnjurosText(Template4CompanyDetails.CLIENTS_PHONE_INFO)

                            }
                        }
                        Link(path = "mailto:${Template4Constants.CLIENTS_EMAIL}",
                            modifier=Modifier.textDecorationLine(TextDecorationLine.None)) {
                            P(
                                attrs = Modifier

                                    .margin(top = animatedMargin.value)
                                    .transition(
                                        Transition.of(
                                            "margin", 1300.ms,
                                            delay = 400.ms
                                        )
                                    )

                                    .fontFamily(Template4Constants.FONT_FAMILY)
                                    .fontSize(24.px)
                                    .color(Colors.White)
                                    .fontWeight(FontWeight.Bold)
                                    .toAttrs()
                            ) {
                                AnjurosText(Template4CompanyDetails.CLIENTS_EMAIL_INFO)

                            }
                        }
                }
            }
        }
        AnjurosImage(
            src = Template4Res.Image.template4_contact2,
            alt = "Web design for self-employed sole traders UK",
            modifier = Modifier.displayIfAtLeast(Breakpoint.MD).height(400.px).fillMaxWidth(33.percent).objectFit(ObjectFit.Fill)
        )
    }
}

@Composable
fun Template4ContactBox(
    modifier: Modifier = Template4FormWidthStyle.toModifier()
) {
    var success by remember { mutableStateOf(false) }


    Box(
        modifier = modifier
            .margin(topBottom =50.px)
            .padding(30.px)
            .position(Position.Relative)
            .border(
                width = 1.px,
                color = Theme.DarkGrey.rgb,
                style = LineStyle.Solid
            ).boxShadow(
                2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
            )
            .borderRadius(5.px),
        contentAlignment = Alignment.Center
    ) {


        ContactForm(
            isDemo = true,
            buttonColor = Template4Theme.Primary.getColor(),
            contactItemsList = listOf(
                NAME_CONTACT_FORM.copy(index = 0),
                PHONE_NUMBER_CONTACT_FORM.copy(index = 1),
                EMAIL_CONTACT_FORM.copy(index = 2,
                    required = false,
                    validations = listOf()
                ),
                ContactFormInfo(
                    index=3,
                    type = ContactFormDetailsType.TICK_BOX,
                    placeholderText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_AREA_LABEL,
                    labelText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_AREA_LABEL,
                    nameText = "Areas needed work",
                    required = false,
                    optionList = listOf(
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX1,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX2,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX3,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX4,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX5,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX6,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX7,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX8,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX9,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX10,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX11,
                        ResKey.TEMPLATE4_CONTACT_CHECKBOX12,
                    ),
                    validations = listOf()
                ), ContactFormInfo(
                    index=4,
                    type = ContactFormDetailsType.TICK_BOX,
                    placeholderText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_WHAT_WORK_LABEL,
                    labelText = com.anjuros.website.components.language.ResKey.CONTACT_FORM_WHAT_WORK_LABEL,
                    nameText = "Needed work",
                    required = false,
                    optionList = listOf(
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX13,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX14,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX15,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX16,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX17,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX18,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX19,
                       ResKey.TEMPLATE4_CONTACT_CHECKBOX20,
                    ),
                    validations = listOf()
                ),
                MESSAGE_CONTACT_FORM.copy(index = 5),
            )
        ) {
            success = true
        }
        SuccessContactMessage(
            isDemo = true,
            showSuccess = success,
            onClose = { success = false }
        )
    }
}